// extracted by mini-css-extract-plugin
export var homeMoreResource = "index-module--homeMoreResource--5Nl45";
export var icon = "index-module--icon--UpzOK";
export var iconLink = "index-module--iconLink--JOAAr";